export default __webpack_public_path__ + "static/media/in-Progress@1.5x.1f1a0a3d.svg";